var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[_c('Header',{staticClass:"template__header"}),_c('div',{staticClass:"template__content"},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }